import { CommonFormGrid } from 'components/form/grid';
import { FormHeading } from 'components/form/heading';
import { FormSelect } from 'components/form/select';
import { FormTextArea } from 'components/form/textarea';
import { FormTextField } from 'components/form/textfield';
import { EB } from 'components/layout/error-boundary';
import { FormContext } from 'contexts/form';
import { OptionDef } from 'interfaces/options';
import { CustodianDoc } from 'lib/interfaces/database/custodian';
import { useContext, useEffect, useMemo, useState } from 'react';
import useIssuersStore from 'stores/issuers';

export const CustodianForm = () => {
  const { data: issuers, load: loadIssuers } = useIssuersStore();

  useEffect(() => {
    loadIssuers();
  }, []);

  const { data, setData } = useContext(FormContext);

  const [defaultData] = useState<Partial<CustodianDoc>>(data);

  const issuerOptions = useMemo<OptionDef[]>(
    () =>
      issuers.map((m) => ({
        label: m.name,
        value: m.id,
      })),
    [issuers]
  );

  return (
    <EB>
      <CommonFormGrid columns="1">
        <FormHeading label="Custodian" />

        <FormSelect
          label="Issuer"
          defaultValue={defaultData.issuerID}
          options={issuerOptions}
          onChange={(v) => {
            const payload: Partial<CustodianDoc> = {
              issuerID: v,
            };
            setData(payload);
          }}
          required
        />

        <FormTextField
          label="Name"
          defaultValue={defaultData.name}
          onChange={(v) => {
            const payload: Partial<CustodianDoc> = {
              name: v,
            };
            setData(payload);
          }}
          required
        />

        <FormTextArea
          label="Notes"
          defaultValue={defaultData.notes}
          onChange={(v) => {
            const payload: Partial<CustodianDoc> = {
              notes: v,
            };
            setData(payload);
          }}
        />
      </CommonFormGrid>
    </EB>
  );
};
